import CommonOrders from "../../common/CommonOrders"
const Cancelled=()=>{
     const columnDefs = [
            { field: "orderId", headerName: "Order ID" },
            { field: "orderType", headerName: "Order Type" },
            {
        field: "dateCreated",
        headerName: "Date Created",
      },
            { field: "wayBill", headerName: "WayBill" },
            { field: "courier", headerName: "Courier" },
            { field: "customerName", headerName: "Customer Name" },
            { field: "mobile", headerName: "Mobile" },
            { field: "email", headerName: "Email" },
            { field: "pincode", headerName: "Pincode" },
            { field: "city" },
            { field: "totalAmount", headerName: "Total Amount" },
            {
                headerName: "Products",
                field: "product",
                flex: 5,
                wrapText: true,
                autoHeight: true,
            },
            { field: "paymentType", headerName: "Payment Type" },
            { field: "diseaseName", headerName: "Disease Name" },
            { field: "courierStatus", headerName: "Courier Status" },
             {
        field: "teleCaller",
        headerName: "Tele Caller",
      },
      {
        field: "teamLeader",
        headerName: "Team Leader",
      },
        ]
    // All Grid Columns
    return (
        <>
        <CommonOrders statusId={6} columnDefs={columnDefs} h4={"Cancelled Orders"} />
        </>
    );
}
export default Cancelled;